import { createSelector } from "@reduxjs/toolkit";

interface CommonProperties {
   isSuperUser: boolean;
   isVenueAdmin: boolean;
   isSalesRep: boolean;
   isEnterpriseAccountAdmin: boolean;
   isMemberGroupAdmin: boolean;
   isOrganizationAdmin: boolean;
   isCalendarAdmin: boolean;
   isSystemAdmin: boolean;
   isAffiliate: boolean;
   isVenueGroupAdmin: boolean;
   enterpriseAccountAdmin: Guid[];
   IsEnterprise: boolean;   
}

interface AuthenticatedProperties {
   isAuthenticated: true;
   id: Guid,
   email: string;

   firstName: string | null;
   lastName: string | null;
   fullName: string | null;
   imageUrl: string | null;

   ssoLoginType: LSCrossTier.SsoType | null;
}

interface AnonymousProperties {
   isAuthenticated: false,
   id: null,
   email: null;

   firstName: null;
   lastName: null;
   fullName: null;
   imageUrl: null;

   ssoLoginType: null;
}

export type UserSelectorModel = CommonProperties & (AuthenticatedProperties | AnonymousProperties);

export const userSelector = createSelector<[(state: LSStore.State) => LSCommon.Models.UserJsModel], UserSelectorModel>(
   [(state) => state.user.value],
   (user) => ({
      ...{
         isSuperUser: user.roles.some(x => x == LSCommon.MemberRole.SuperUser),
         isVenueAdmin: user.roles.some(x => x == LSCommon.MemberRole.VenueAdmin),
         isSalesRep: user.roles.some(x => x == LSCommon.MemberRole.SalesRep),
         isEnterpriseAccountAdmin: user.roles.some(x => x == LSCommon.MemberRole.EnterpriseAccountAdmin),
         isMemberGroupAdmin: user.roles.some(x => x == LSCommon.MemberRole.MemberGroupAdmin),
         isOrganizationAdmin: user.roles.some(x => x == LSCommon.MemberRole.OrganizationAdmin),
         isCalendarAdmin: user.roles.some(x => x == LSCommon.MemberRole.CalendarAdmin),
         isSystemAdmin: user.roles.some(x => x == LSCommon.MemberRole.SysAdmin),
         isAffiliate: user.roles.some(x => x == LSCommon.MemberRole.AffiliateUser),
         isVenueGroupAdmin: user.roles.some(x => x == LSCommon.MemberRole.VenueGroupAdmin),
         IsEnterprise: user.IsEnterprise
      } as CommonProperties,
      ...(
         user.id != null && user.id != Guid.Empty
            ? {
               isAuthenticated: true,
               firstName: user.firstName,
               lastName: user.lastName,
               fullName: user.fullName,
               imageUrl: user.imageUrl,
               email: user.email,
               ssoLoginType: user.ssoLoginType,
               id: user.id,
               enterpriseAccountAdmin: user.enterpriseAccountAdmin
            } as AuthenticatedProperties
            : {
               isAuthenticated: false,
               firstName: null,
               lastName: null,
               fullName: null,
               imageUrl: null,
               email: null,
               ssoLoginType: null,
               id: null,
               enterpriseAccountAdmin: [] as Guid[]
            } as AnonymousProperties
      )
   })
)